import React, { ReactElement } from 'react';
import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { AlyceTheme } from '@alycecom/ui';

import AlyceLogo from '../Shared/AlyceLogo';
import AlyceLogoSvg from '../../assets/images/alyce-logo.svg';

export interface IAlyceCentredHeaderProps {
  image?: string;
}

const useStyles = makeStyles<AlyceTheme>(({ breakpoints }) => ({
  root: {
    boxShadow: '0 2px 32px 0 rgba(0, 0, 0, 0.2)',
  },
  childrenWrapper: {
    [breakpoints.down('sm')]: {
      opacity: 0.9,
    },
  },
}));

const AlyceCentredHeader = ({ image }: IAlyceCentredHeaderProps): ReactElement => {
  const classes = useStyles();
  const logo = image || AlyceLogoSvg;
  return (
    <Box
      className={classes.root}
      width={1}
      height={[56, 80]}
      display="flex"
      alignItems="center"
      justifyContent="center"
      bgcolor="common.white"
    >
      <AlyceLogo image={logo} />
    </Box>
  );
};

export default AlyceCentredHeader;
